var render = function () {
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"clipboard",rawName:"v-clipboard:copy",value:(_vm.ColorCode),expression:"ColorCode",arg:"copy"}],staticClass:"color-card md:color-card-md",style:(("background-color: " + _vm.ColorCode)),on:{"click":function($event){_vm.show = !_vm.show}}},[_c('ColorText',{attrs:{"ColorCode":_vm.ColorCode}}),_c('CopyAlert',{attrs:{"alertMessage":"✔ Copy!","triggerAlert":_vm.show},on:{"hideAlert":function (e) {
        this$1.show = e
      }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }